import { ObituaryResponseParlorField } from "@/containers/BugoContainer/type";
import styled from "@emotion/styled";
import {
  ColorIcon,
  colors,
  HStack,
  useAlertDialog,
  useMap,
  VStack,
} from "goi_common";
import router from "next/router";

interface ParlorMapProps {
  parlor?: ObituaryResponseParlorField;
  title?: string;
  description?: string;
}

export function ParlorMap({ parlor, title, description }: ParlorMapProps) {
  const id = useMap(
    parlor?.latitude ?? 33.4507,
    parlor?.longitude ?? 126.570667,
    false,
    false
  );

  const { openAlertDialog } = useAlertDialog();

  const onNavigationClick = () => {
    openAlertDialog({
      content: "준비 중입니다.",
      buttonText: "확인",
    });
  };

  return (
    <VStack gap="12px">
      {title && <div className="subtitle_18_sb">{title}</div>}
      {description && (
        <div
          className="caption_16_m gray800"
          css={{
            whiteSpace: "pre-wrap",
          }}
        >
          {description}
        </div>
      )}
      <Map id={id} />
      {parlor?.address && (
        <VStack
          as="button"
          width="100%"
          justifyContent="center"
          alignItems="flex-start"
          css={{
            borderRadius: "10px",
            background: colors.white,
            boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.12)",
            padding: "24px",
          }}
          // onClick={onNavigationClick}
        >
          <HStack gap="8px">
            <ColorIcon name="icon-location-marker" size={24} color="" />
            <VStack justifyContent="flex-start">
              <div
                className="body_16_m gray900"
                css={{
                  textAlign: "left",
                  lineHeight: "16px",
                }}
              >
                {parlor?.companyname}
              </div>
              <div
                className="caption_14_m gray700"
                css={{
                  textAlign: "left",
                }}
              >
                {parlor?.address}
              </div>
            </VStack>
          </HStack>
        </VStack>
      )}
      {parlor?.address && (
        <HStack gap={15} css={{ margin: "0px 0px 10px" }}>
          <VStack
            as="button"
            gap="4px"
            width="100%"
            justifyContent="center"
            alignItems="center"
            css={{
              borderRadius: "10px",
              background: colors.white,
              boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.12)",
              padding: "24px",
            }}
            onClick={() =>
              router.push(
                `https://map.kakao.com/link/map/${parlor.companyname},${parlor.latitude},${parlor.longitude}`
              )
            }
          >
            <ColorIcon name="icon-public-transportation" size={20} color="" />
            <div className="body3_m font-500 gray700">대중교통</div>
          </VStack>
          <VStack
            as="button"
            gap="4px"
            width="100%"
            justifyContent="center"
            alignItems="center"
            css={{
              borderRadius: "10px",
              background: colors.white,
              boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.12)",
              padding: "24px",
            }}
            onClick={onNavigationClick}
          >
            <ColorIcon name="icon-navigation" size={20} color="" />
            <div className="body3_m font-500 gray700">내비게이션</div>
          </VStack>
        </HStack>
      )}
    </VStack>
  );
}

const Map = styled.div`
  margin: auto;
  border-radius: 5px;
  width: 100%;
  aspect-ratio: 327 / 210;
  z-index: 0;
`;
